/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable} from '@angular/core';
import { AppService } from '../api.service';
import { ProjectsService } from './project.service';

@Injectable({
  providedIn: 'root'
})
export class CartService {
  is_my_list = false;
  sample_count=0;
  constructor(public _as: AppService,private _project:ProjectsService) { }

  addToMyList(pId: any, qty: number,project_id:any) {
      const url = this._as.api_base_url + 'search/add-to-cart-v2/' + project_id + '/';
      const my_data = {
        product: pId,
        quantity: qty,
      };
      return this._as.putRequest(url, my_data, true).toPromise();
  }

  myListStatus(){
    if(!this._as.isUserLoggedIn){
      this.is_my_list = true;
      return
    }
    if(this._project.selectedProject){
      if(this._project.selectedProject.is_assigned && !this._as.user_info.is_service_provider){
        this.is_my_list = false
      }else{
        this.is_my_list = true
      }
      return
    }
    if(this._as.user_info.is_service_provider || !this._as.user_info.is_assigned){
      this.is_my_list = true;
      return
    }else{
      this.is_my_list = false;
      return
    }
  }
  getSampleCartStatus(){
    const url = this._as.api_base_url + 'ims/cart-product-count/';
    this._as.getRequest(url,true).subscribe((res:any)=>{
      if(res){
        this.sample_count = res.sample_cart_count
        // this._router.navigate([`dealer`], { queryParams: { page: this.page_number, mcId: this.activeMainCategoryId, cityId: this.city_id } })
      }
    },
    
    (err:any)=>{
      if(err){
       console.log("err",err)
      }
    })
  }
}
